import React from 'react'
import { Switch, Route} from 'react-router-dom'
import Home from './Home'
import AdminGallery from './admin/adminGallery'
import Gallery from './Gallery'
import AboutUs from './aboutus';
import Login from './Login';
import Cart from './Cart';
import Category from './admin/Category';


const Body = () => (
    <main>
      <Switch>
        <Route exact path='/' component={Home}/>
        <Route exact path='/gallery' component={Gallery}/>
        {/* <Route exact path='/gallery/:cat' component={Gallery}/> */}
        <Route exact path='/aboutus' component={AboutUs}/>
        <Route exact path='/login' component={Login}/>
        <Route exact path='/cart' component={Cart}/>
        <Route exact path='/adminGallery' component={AdminGallery}/>
        <Route exact path='/category' component={Category}/>

      </Switch>
    </main>
  )
  export default Body;


// WEBPACK FOOTER //
// ./src/Body.jsx